<template>
  <section class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <h1>Mi Perfil</h1>
        </div>
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><router-link to="/">Home</router-link></li>
            <li class="breadcrumb-item active">Perfil</li>
          </ol>
        </div>
      </div>
    </div>
  </section>

  <section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-4">
          <!-- Profile Image / Info Card -->
          <div class="card card-primary card-outline">
            <div class="card-body box-profile">
              <div class="text-center">
                <img class="profile-user-img img-fluid img-circle"
                     src="/adminlte/dist/img/user2-160x160.jpg"
                     alt="User profile picture">
              </div>
              <h3 class="profile-username text-center">{{ user.name }}</h3>
              <p class="text-muted text-center">{{ user.email }}</p>
              <ul class="list-group list-group-unbordered mb-3">
                <li class="list-group-item">
                  <b>Roles</b> <a class="float-right">{{ user.roles?.map(r => r.name).join(', ') || 'Usuario' }}</a>
                </li>
                <li class="list-group-item">
                  <b>Permisos</b> 
                  <a class="float-right">
                    {{ user.roles?.some(r => r.name.toLowerCase() === 'admin') ? 'Todos' : 
                       (user.permissions?.map(p => p.name).join(', ') || 'Ninguno') }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="col-md-8">
          <div class="card">
            <div class="card-header p-2">
              <ul class="nav nav-pills">
                <li class="nav-item"><a class="nav-link active" href="#settings" data-toggle="tab">Configuración de Cuenta</a></li>
              </ul>
            </div>
            <div class="card-body">
              <div class="tab-content">
                <div class="active tab-pane" id="settings">
                  <form class="form-horizontal" @submit.prevent="updateProfile">
                    <div class="form-group row">
                      <label for="inputName" class="col-sm-3 col-form-label">Nombre Completo</label>
                      <div class="col-sm-9">
                        <input type="text" v-model="form.name" class="form-control" id="inputName" placeholder="Nombre" required>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="inputEmail" class="col-sm-3 col-form-label">Email</label>
                      <div class="col-sm-9">
                        <input type="email" v-model="form.email" class="form-control" id="inputEmail" placeholder="Email" required>
                      </div>
                    </div>
                    <hr>
                    <div class="form-group row">
                      <label for="inputPass" class="col-sm-3 col-form-label">Nueva Contraseña</label>
                      <div class="col-sm-9">
                        <input type="password" v-model="form.password" class="form-control" id="inputPass" placeholder="Dejar en blanco para no cambiar">
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="inputPassConf" class="col-sm-3 col-form-label">Confirmar Contraseña</label>
                      <div class="col-sm-9">
                        <input type="password" v-model="form.password_confirmation" class="form-control" id="inputPassConf" placeholder="Repita la nueva contraseña">
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="offset-sm-3 col-sm-9">
                        <button type="submit" class="btn btn-primary" :disabled="loading">
                          <i v-if="loading" class="fas fa-spinner fa-spin mr-1"></i>
                          Actualizar Datos
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, reactive, onMounted, getCurrentInstance } from 'vue';
import api from '@/services/api';

const { proxy } = getCurrentInstance();
const loading = ref(false);
const user = ref({
  name: '',
  email: '',
  role: ''
});

const form = reactive({
  name: '',
  email: '',
  password: '',
  password_confirmation: ''
});

const fetchUserData = async () => {
  try {
    // Asumiendo que existe un endpoint /me o /perfil que devuelve el usuario autenticado
    const { data } = await api.get('/perfil');
    user.value = data;
    form.name = data.name;
    form.email = data.email;
  } catch (error) {
    console.error("Error al cargar perfil:", error);
  }
};

const updateProfile = async () => {
  if (form.password && form.password !== form.password_confirmation) {
    proxy.$toast({ icon: 'error', title: 'Las contraseñas no coinciden' });
    return;
  }

  loading.value = true;
  try {
    await api.put('/perfil', form);
    proxy.$toast({ icon: 'success', title: 'Perfil actualizado correctamente' });
    fetchUserData();
    form.password = '';
    form.password_confirmation = '';
  } catch (error) {
    proxy.$toast({ 
      icon: 'error', 
      title: error.response?.data?.message || 'Error al actualizar perfil' 
    });
  } finally {
    loading.value = false;
  }
};

onMounted(fetchUserData);
</script>

<style scoped>
.profile-user-img {
  width: 100px;
  margin: 0 auto;
}
</style>
